import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { Collapsible } from '@euler/components/collapsible';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { QuotationSubject } from '@euler/model/task-detail';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { ReadonlyQuotationSubjectConstructionItemView } from './ConstructionItemView';
import { ReadonlySubjectIssueList } from './SubjectIssueList';
import { ReadonlyQuotationFormSubjectPanelHeader } from './SubjectPanelHeader';
import { ReadonlyQuotationSubjectSubTotalInfo } from './SubjectSubTotalInfo';

export const ReadonlyQuotationFormSubjectPanel = memo(
  ({
    index,
    subject,
    style,
  }: {
    index: number;
    subject: QuotationSubject;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();

    return (
      <Collapsible.Panel
        style={style}
        headerContainerStyle={{ alignItems: 'center' }}
        headerStyle={{ paddingRight: rpx(10) }}
        caretColor="#777"
        header={
          <ReadonlyQuotationFormSubjectPanelHeader
            index={index}
            title={subject.name}
          />
        }
        css={`
          background-color: #fff;
          padding-top: ${rpx(10)}px;
          padding-bottom: ${rpx(10)}px;
        `}
      >
        <Content subject={subject} />
      </Collapsible.Panel>
    );
  },
);

const Content = memo(({ subject }: { subject: QuotationSubject }) => {
  const { rpx } = useResponsiveContext();

  return (
    <>
      <ReadonlySubjectIssueList
        issues={subject.issues}
        css={`
          margin-top: ${rpx(8)}px;
        `}
      />
      <StackLayout
        gap={rpx(15)}
        css={`
          margin-top: ${rpx(8)}px;
        `}
      >
        {subject.items.map(item => (
          <ReadonlyQuotationSubjectConstructionItemView
            item={item}
            key={item.name}
          />
        ))}
        {subject.items.length === 0 && <EmptyConstructionItems />}
        <ReadonlyQuotationSubjectSubTotalInfo
          subject={subject}
          css={`
            border-top-width: 1px;
            border-top-color: #ddd;
            padding-top: ${rpx(8)}px;
          `}
        />
      </StackLayout>
    </>
  );
});

const EmptyConstructionItems = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <StackLayout
      direction="row"
      alignItems="center"
      gap={rpx(3)}
      css={`
        padding: ${rpx(5)}px 0;
      `}
    >
      <Icon name="information-outline" size={rpx(14)} color="#aaa" />
      <Typography.Text size={rpx(14)} color="#aaa">
        尚未相关施工项目
      </Typography.Text>
    </StackLayout>
  );
});
